import { useQuery } from "@tanstack/react-query"

import { getUnits } from "@/api/getUnits.ts"

export default function RenderUnit({ id }: { id: number }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
  })

  if (isPending) return <>Loading...</>
  if (isError) return <>Network Error</>
  const unit = data.find((u) => u.id == id)
  return <>{unit?.name || "N/A"}</>
}
